(function () {
  var section = document.querySelector('[data-ghost-featured]');
  if (!section) return;

  var tabs = section.querySelectorAll('[data-featured-tab]');
  var featuredSlot = section.querySelector('[data-featured-slot]');
  var pagination = section.querySelector('[data-featured-pagination]');
  var pageNumbers = section.querySelector('[data-page-numbers]');
  var pageLabel = section.querySelector('[data-featured-page-label]');
  var emptyState = section.querySelector('[data-featured-empty]');
  var pageSize = Number(section.getAttribute('data-page-size') || 10);
  var activeTab = 0;
  var currentPage = 1;

  function getFeaturedStory() {
    return section.querySelector('[data-featured-story]');
  }

  function getStoryRows() {
    return Array.prototype.slice.call(section.querySelectorAll('[data-story-row]'));
  }

  function activeFilter() {
    var tab = tabs[activeTab];
    return tab ? tab.getAttribute('data-filter') || '' : '';
  }

  function filteredRows() {
    var filter = activeFilter();
    return getStoryRows().filter(function (row) {
      if (row.getAttribute('data-featured') === 'true') return false;
      if (!filter) return true;
      return row.getAttribute('data-category') === filter;
    });
  }

  function renderPageNumbers(totalPages) {
    if (!pageNumbers) return;
    pageNumbers.innerHTML = '';

    for (var page = 1; page <= totalPages; page += 1) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ghost-featured__page-number' + (page === currentPage ? ' is-active' : '');
      button.setAttribute('data-page-number', String(page));
      button.setAttribute('aria-current', page === currentPage ? 'page' : 'false');
      button.textContent = String(page);
      pageNumbers.appendChild(button);
    }
  }

  function render() {
    var filter = activeFilter();
    var featured = getFeaturedStory();
    var rows = filteredRows();
    var showFeatured = !filter && currentPage === 1 && featured;
    var totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
    if (currentPage > totalPages) currentPage = totalPages;

    if (featuredSlot) featuredSlot.hidden = !showFeatured;
    if (featured) featured.hidden = !showFeatured;

    rows.forEach(function (row) {
      row.hidden = true;
    });

    var start = (currentPage - 1) * pageSize;
    var visibleRows = rows.slice(start, start + pageSize);
    visibleRows.forEach(function (row) {
      row.hidden = false;
    });

    if (emptyState) {
      emptyState.hidden = showFeatured || visibleRows.length > 0;
    }

    if (pageLabel) {
      if (totalPages > 1) {
        pageLabel.textContent = 'Page ' + currentPage + ' of ' + totalPages;
        pageLabel.hidden = false;
      } else {
        pageLabel.hidden = true;
      }
    }

    if (pagination) {
      pagination.hidden = totalPages <= 1;
      renderPageNumbers(totalPages);
      var prev = pagination.querySelector('[data-page-prev]');
      var next = pagination.querySelector('[data-page-next]');
      if (prev) prev.disabled = currentPage === 1;
      if (next) next.disabled = currentPage === totalPages;
    }
  }

  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () {
      activeTab = index;
      currentPage = 1;
      tabs.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === activeTab);
        item.setAttribute('aria-selected', itemIndex === activeTab ? 'true' : 'false');
      });
      render();
    });
  });

  if (pagination) {
    pagination.addEventListener('click', function (event) {
      var target = event.target.closest('[data-page-number], [data-page-prev], [data-page-next]');
      if (!target) return;

      if (target.hasAttribute('data-page-prev')) {
        currentPage = Math.max(1, currentPage - 1);
      } else if (target.hasAttribute('data-page-next')) {
        currentPage += 1;
      } else {
        currentPage = Number(target.getAttribute('data-page-number') || 1);
      }

      render();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  render();
})();
